import { render, staticRenderFns } from "./EditBadgeDialog.vue?vue&type=template&id=3ddbcdf6&"
import script from "./EditBadgeDialog.vue?vue&type=script&lang=js&"
export * from "./EditBadgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports